// Autogenerated file
export const relationToTypesEnum = {
    Bid: "Bid",
    DistributionBid: "DistributionBid",
};
export const relationToTypes = [
    { label: "Заявка", value: "Bid" },
    { label: "Заказ", value: "DistributionBid" },
];
